"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M12 6H4a2 2 0 100 4h8a2 2 0 100-4zM4 4a4 4 0 100 8h8a4 4 0 000-8H4z"];
//# sourceMappingURL=stadium-geometry.js.map